import React from "react";
import "./UsageHistory.css";
import { useEffect, useState } from "react";
import { getDepositLogAPI } from "../../../../api/index";
import { useAuth } from "../../../../hooks/useAuth"; // ✅ 추가

// formatAmount 함수 안전장치 추가
const formatAmount = (amount) => {
  if (amount === undefined || amount === null) return "0원";
  const sign = amount > 0 ? "+" : "";
  return `${sign}${amount.toLocaleString("ko-KR")}원`;
};

const UsageHistory = () => {
  const { user } = useAuth(); // ✅ 추가
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const itemsPerPage = 6;

  useEffect(() => {
    const fetchUsageHistory = async () => {
      setLoading(true);
      setError(null);

      // ✅ 맨 처음에 로그인 상태 체크 (API 호출 전에)
      if (!user?.id) {
        const mockUsageHistory = [
          {
            id: 1,
            title: "'올려줌 헤어샵' 플레이스 방문 광고 등록",
            amount: -50000,
            balance: 10000,
            created_at: "2025-08-21T09:30:00.000Z",
            description: "네이버 키워드 광고 사용",
          },
          {
            id: 2,
            title: "'올려줌 건전지' 쇼핑 광고 등록",
            amount: -50000,
            balance: 60000,
            created_at: "2025-08-20T14:20:00.000Z",
            description: "메인 배너 광고 사용",
          },
          {
            id: 3,
            title: "충전 완료",
            amount: 100000,
            balance: 110000,
            created_at: "2025-08-20T10:15:00.000Z",
            description: "예치금 충전",
          },
          {
            id: 4,
            title: "'올려줌 헤어샵' 플레이스 저장 광고 등록",
            amount: -50000,
            balance: 10000,
            created_at: "2025-08-19T16:45:00.000Z",
            description: "프리미엄 광고 패키지 사용",
          },
          {
            id: 5,
            title: "'올려줌 건전지' 쇼핑 광고 등록",
            amount: -40000,
            balance: 60000,
            created_at: "2025-08-19T11:30:00.000Z",
            description: "구글 검색 광고 사용",
          },
          {
            id: 6,
            title: "충전 완료",
            amount: 100000,
            balance: 100000,
            created_at: "2025-08-18T13:20:00.000Z",
            description: "예치금 충전",
          },
        ];

        // 클라이언트 페이지네이션
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const paginatedData = mockUsageHistory.slice(startIndex, endIndex);

        setData(paginatedData);
        setTotalPages(Math.ceil(mockUsageHistory.length / itemsPerPage));
        setLoading(false);
        return; // ✅ 여기서 완전 종료 (API 호출 안 함)
      }

      // ✅ 여기까지 오면 로그인 상태이므로 API 호출
      try {
        const response = await getDepositLogAPI({
          page: 1,
          pageSize: 100,
          web_member_id: user.id,
        });

        // "충전 신청", "환불 신청" 제외 필터링
        const allFilteredData = (response.data.list || []).filter(
          (item) => item.title !== "충전 요청" && item.title !== "환불 신청"
        );

        // 클라이언트 페이지네이션
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const paginatedData = allFilteredData.slice(startIndex, endIndex);

        setData(paginatedData);
        setTotalPages(Math.ceil(allFilteredData.length / itemsPerPage));
      } catch (err) {
        console.error("상세 에러:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsageHistory();
  }, [currentPage, itemsPerPage, user?.id]);

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const formatAmount = (amount) => {
    const sign = amount > 0 ? "+" : "";
    return `${sign}${amount.toLocaleString("ko-KR")}원`;
  };

  if (loading) {
    return (
      <div className="usage-history-container">
        <div className="history-header">
          <h3 className="history-title">예치금 이용내역</h3>
        </div>
        <div>로딩 중...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="usage-history-container">
        <div className="history-header">
          <h3 className="history-title">예치금 이용내역</h3>
        </div>
        <div>에러가 발생했습니다: {error}</div>
      </div>
    );
  }

  return (
    <div className="usage-history-container">
      <div className="history-header">
        <h3 className="history-title">예치금 이용내역</h3>
        <div className="pagination-controls">
          <button onClick={handlePrevPage} disabled={currentPage === 1}>
            &lt;
          </button>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
        </div>
      </div>
      <ul className="usage-history-list">
        {data.map((item, index) => (
          <li key={item.id || index} className="usage-item">
            <div className="usage-item-left">
              <span className="usage-date">
                {new Date(item.created_at).toLocaleDateString("ko-KR")}
              </span>
              <div className="usage-details">
                <span className="usage-description">{item.title}</span>
                <span className="usage-time">
                  {new Date(item.created_at).toLocaleTimeString("ko-KR", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
              </div>
            </div>
            <div className="usage-item-right">
              <span
                className={`usage-change-amount ${
                  item.amount < 0 ? "negative" : "positive"
                }`}
              >
                {formatAmount(item.amount)}
              </span>
              <span className="usage-balance">
                {item.balance?.toLocaleString("ko-KR") || "0"}원
              </span>
            </div>
          </li>
        ))}
      </ul>
      {data.length === 0 && (
        <div className="no-data-message">이용내역이 없습니다.</div>
      )}
    </div>
  );
};

export default UsageHistory;
